/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * BeLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {ArchiveQrCodesBody} from './schemas/archive-qr-codes-body';

import type {CreateQrCode200} from './schemas/create-qr-code200';

import type {CrupdateQrCodeBody} from './schemas/crupdate-qr-code-body';

import type {DeleteQrCodesParams} from './schemas/delete-qr-codes-params';

import type {ExportQrCodesCsvBody} from './schemas/export-qr-codes-csv-body';

import type {ExportQrCodesCsv200} from './schemas/export-qr-codes-csv200';

import type {ListQrCodesParams} from './schemas/list-qr-codes-params';

import type {ListQrCodes200} from './schemas/list-qr-codes200';

import type {RetrieveQrCode200} from './schemas/retrieve-qr-code200';

import type {UnarchiveQrCodesBody} from './schemas/unarchive-qr-codes-body';

import type {UpdateQrCode200} from './schemas/update-qr-code200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all QR codes
 */
export const listQrCodes = (
  params?: ListQrCodesParams,
  options?: SecondParameter<typeof orvalApiFetch<ListQrCodes200>>,
) => {
  return orvalApiFetch<ListQrCodes200>(
    {url: `/qr-code`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a QR code
 */
export const createQrCode = (
  crupdateQrCodeBody?: CrupdateQrCodeBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateQrCode200>>,
) => {
  return orvalApiFetch<CreateQrCode200>(
    {
      url: `/qr-code`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: crupdateQrCodeBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a QR code
 */
export const retrieveQrCode = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveQrCode200>>,
) => {
  return orvalApiFetch<RetrieveQrCode200>(
    {url: `/qr-code/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Update a QR code
 */
export const updateQrCode = (
  id: number,
  crupdateQrCodeBody?: CrupdateQrCodeBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateQrCode200>>,
) => {
  return orvalApiFetch<UpdateQrCode200>(
    {
      url: `/qr-code/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: crupdateQrCodeBody,
    },
    options,
  );
};
/**
 * @summary Delete multiple QR codes
 */
export const deleteQrCodes = (
  params: DeleteQrCodesParams,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/qr-codes/bulk`, method: 'DELETE', params},
    options,
  );
};
/**
 * @summary Archive QR codes
 */
export const archiveQrCodes = (
  archiveQrCodesBody: ArchiveQrCodesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/qr-codes/bulk/archive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: archiveQrCodesBody,
    },
    options,
  );
};
/**
 * @summary Unarchive QR codes
 */
export const unarchiveQrCodes = (
  unarchiveQrCodesBody: UnarchiveQrCodesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/qr-codes/bulk/unarchive`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: unarchiveQrCodesBody,
    },
    options,
  );
};
/**
 * @summary Export QR codes as CSV
 */
export const exportQrCodesCsv = (
  exportQrCodesCsvBody: ExportQrCodesCsvBody,
  options?: SecondParameter<typeof orvalApiFetch<ExportQrCodesCsv200>>,
) => {
  return orvalApiFetch<ExportQrCodesCsv200>(
    {
      url: `/qr-code/csv/export`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: exportQrCodesCsvBody,
    },
    options,
  );
};
export type ListQrCodesResult = NonNullable<
  Awaited<ReturnType<typeof listQrCodes>>
>;
export type CreateQrCodeResult = NonNullable<
  Awaited<ReturnType<typeof createQrCode>>
>;
export type RetrieveQrCodeResult = NonNullable<
  Awaited<ReturnType<typeof retrieveQrCode>>
>;
export type UpdateQrCodeResult = NonNullable<
  Awaited<ReturnType<typeof updateQrCode>>
>;
export type DeleteQrCodesResult = NonNullable<
  Awaited<ReturnType<typeof deleteQrCodes>>
>;
export type ArchiveQrCodesResult = NonNullable<
  Awaited<ReturnType<typeof archiveQrCodes>>
>;
export type UnarchiveQrCodesResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveQrCodes>>
>;
export type ExportQrCodesCsvResult = NonNullable<
  Awaited<ReturnType<typeof exportQrCodesCsv>>
>;
